import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { CAMPUSES, CONTACT } from "@/lib/constants";

export const DEFAULT_CONTENT = {
  hero: {
    badge: "Employee Relations Center of Excellence",
    title: "A trusted place for every workplace concern.",
    subtitle:
      "Patria's ER CoE is a consistent, impartial resource for staff and volunteers across all campuses. Bring conflicts, policy questions, or concerns of harassment, discrimination, or retaliation — directly to us, at any time.",
  },
  mission: {
    eyebrow: "Our purpose",
    title: "A dedicated team, committed to consistency and care.",
    body:
      "People Operations maintains the ER CoE — a team of trained specialists who coordinate investigations under our Non-Harassment, Non-Discrimination, and Anti-Retaliation policy, track every concern to resolution, and ensure Patria's policies are applied consistently across campuses.",
    bullets: [
      "Impartial review of every concern",
      "Confidential by design — anonymous reporting welcome",
      "Facilitated conversations to restore relationships",
    ],
  },
  contact: { email: CONTACT.email, phone: CONTACT.phone },
  campuses: CAMPUSES,
};

const ContentContext = createContext(null);
export const useContent = () => useContext(ContentContext);

export function ContentProvider({ children }) {
  const [content, setContent] = useState(DEFAULT_CONTENT);

  const refresh = useCallback(() => {
    return api
      .get("/content")
      .then((r) => setContent({ ...DEFAULT_CONTENT, ...r.data }))
      .catch(() => {});
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <ContentContext.Provider value={{ content, refresh, setContent }}>
      {children}
    </ContentContext.Provider>
  );
}
